import { permissionObj } from '../../../Helpers/permission';
import DeleteModal from '../../Modals/DeleteModal';
import DeleteDeviceModal from './Modals/DeleteDeviceModal';
import DeviceLogModal from './Modals/DeviceLogModal';
import QRCode from 'qrcode.react';
import SearchSimple from '../../../components/SearchSimples/SearchSimple';
import ExportDataBtn from '../../../components/buttons/ExportDataBtn';
import HeadTittle from '../../../components/HeadTittle';
import routes from '../../../Routes/routes';
import {AddIcon, SettingsIcon, TrashOutlineIcon} from '../../../components/buttons/IconButtons';
import ButtonAction from '../../../components/buttons/ButtonAction';
import ButtonIcon from '../../../components/buttons/ButtonIcon';
import CustomTable from "../../../components/table/CustomTable";
import {DevicesPanelApp} from "./Funtionality/DevicesPanelApp";
import CustomButtonLink from "../../../components/buttons/CustomButtonLink";
import OpenDoorByDeviceModal from "./Modals/OpenDoorByDeviceModal";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 * @returns {JSX.Element} - Main component of the device panel
 * @constructor
 *
 */

const DevicesPanel = () => {
    const {
        t,
        navigate,
        handleDeleteAll,
        deleteSelectedDevices,
        setBodyForExport,
        permission,
        DEV,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        showDeleteDeviceModal,
        setShowDeleteDeviceModal,
        modified,
        setModified,
        deleteDeviceShow,
        setDeleteDeviceShow,
        search,
        moduleId,
        option,
        bodyForExport,
        isAllChecked,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        rowsPerPage,
        setResults,
        qrData,
        selectedList,
        showLogModal,
        setShowLogModal,
        logDevice,
        deletePermission,
        openDoorShow,
        setOpenDoorShow,
        itemOpenDoor
    } = DevicesPanelApp();

    return (
        <>
            <HeadTittle name={'devices_panel'}>
                        {(DEV || permission?.includes(permissionObj?.WEB_DEVICE_RESTRICTION_UPDATE)) && (
                            <ButtonIcon
                            id='btn_dp_device_config'
                            Icon={SettingsIcon}
                            url={routes.devices.configuration}
                            title={'modify_settings'}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                            />
                        )}
                        {(DEV || permission?.includes(permissionObj?.WEB_DEVICE_EXPORT)) &&(
                                <ExportDataBtn
                                    id='btn_dp_export_data'
                                    moduleId={moduleId}
                                    searchElement={searchElement}
                                    search={search}
                                    option={option}
                                    body={bodyForExport}
                                />
                            )}
                        {(DEV || permission?.includes(permissionObj?.WEB_DEVICE_CREATE)) && (
                            <ButtonAction
                                id='btn_dp_create'
                                name='create'
                                className='btn-icon-add'
                                Icon={AddIcon}
                                url={routes.devices.create}
                            />
                        )}
                        {(DEV || permission?.includes(permissionObj?.WEB_DEVICE_DELETE)) && (
                            <ButtonAction
                                id='btn_dp_delete'
                                name='delete'
                                className='btn-icon-delete'
                                disabled={selectedList?.length === 0}
                                Icon={TrashOutlineIcon}
                                onClick={()=>{
                                    setDeleteDeviceShow(true);
                                }}
                            />
                        )}

            </HeadTittle>
            <SearchSimple
                id={"txt_dvp_search_simple"}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={true}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_have_not_created_any_device_yet")}</p>
                                 </div>
                                 { (DEV || permission?.includes(permissionObj?.WEB_HID_CREATE)) &&
                                 <CustomButtonLink splitName={false} id={'btn_dp_create'} card={true}
                                                   onClick={() => navigate(routes.devices.create)}
                                                   name={'create_new_device'}/>
                                 } </>
                             : undefined
                         }
            />
            {pagination()}

            <DeleteDeviceModal
                show={showDeleteDeviceModal}
                onHide={() => setShowDeleteDeviceModal(false)}
                data={selectedList}
                flag={modified}
                onDelete={() => setModified(true)}
            />

            <div className='d-none'>
                <QRCode id='qr-gen' value={qrData} size={290} level={'H'} includeMargin={true} />
            </div>

            {showLogModal &&
                <DeviceLogModal
                    show={showLogModal}
                    onHide={() => {
                        setShowLogModal(false);
                    }}
                    data={logDevice}
                />
            }
            <DeleteModal
                show={deleteDeviceShow}
                onHide={() => setDeleteDeviceShow(false)}
                onClickFn={() => deleteSelectedDevices(selectedList)}
                data={selectedList}
                title_modal={t('delete_devices')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('devices')}
            />

            <OpenDoorByDeviceModal
                show={openDoorShow}
                data={itemOpenDoor}
                onHide={() => setOpenDoorShow(false)}
            />
        </>
    );
};

export default DevicesPanel;
